import { faDotCircle } from '@fortawesome/pro-solid-svg-icons';
import { Radio } from 'informed';
import PropTypes from 'prop-types';

import { FAIcon } from 'lib/customPropTypes';

import { Icon } from '../Icons';

import './styles/checkAndRadioStyles.css';

const CustomRadio = ({ children, className, icon, id, value, ...rest }) => {
  return (
    <label className={`custom-radio ${className}`} htmlFor={id}>
      <Radio className="radio" id={id} value={value} {...rest} />
      <Icon icon={icon} />
      <span>{children}</span>
    </label>
  );
};

CustomRadio.defaultProps = {
  className: '',
  icon: faDotCircle,
};

CustomRadio.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: FAIcon,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CustomRadio;
